import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { Loader } from 'components';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, convertFromHTML, ContentState, convertToRaw } from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';


@inject(rootStore => ({
    paperworkEntryStore: rootStore.paperworkEntryStore,
    routerStore: rootStore.routerStore
}))

@observer
class PaperworkEntryImageEditPage extends React.Component {
      state = {
        image : {}
    };

    constructor(props) {
        super(props);
        this.handleRefresh = this.handleRefresh.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleTextEditorChange = this.handleTextEditorChange.bind(this);
        this.state = { 
            editorState: EditorState.createEmpty()
         };
    }

    async handleRefresh() {
        await this.refreshData();
    }

    async componentDidMount() {
        await this.refreshData();
        const { image } = this.props.paperworkEntryStore;
      
        if(image.text == null)
        {
            image.text = "<div>This image doesn't contain text.</div>"
        }
        const blocksFromHTML = convertFromHTML(image.text);
        const state = ContentState.createFromBlockArray(
            blocksFromHTML.contentBlocks,
            blocksFromHTML.entityMap
        );

        const editorState = EditorState.createWithContent(state);

        this.setState({ image, editorState })
    }

    async refreshData() {
        const { paperworkEntryStore, match } = this.props;
        await paperworkEntryStore.getPaperworkEntryImage(match.params.id);
    }

    componentWillUnmount() {
        this.props.paperworkEntryStore.clearMessages();
    }

    handleChange(event) {
        const  image  = {...this.state.image};
        image.name = event.target.value;
        this.setState({image});
    }

    handleTextEditorChange(event, editor) {
        const  image  = {...this.state.image};
        image.text = editor.getData();
        this.setState({image});
    }

    handleSubmit(event) {
        event.preventDefault();
        var imagTextValue = draftToHtml(convertToRaw(this.state.editorState.getCurrentContent()))

        var img = this.state.image;
        img.text = imagTextValue;
        this.props.paperworkEntryStore.updatePaperworkEntryImage(img);
    }

    onEditorStateChange: Function = (editorState) => {
        this.setState({
          editorState,
        });
      }

    renderUpdateResultMessage() {
        const { error, successMessage } = this.props.paperworkEntryStore;
        if(error != null)
        {
           return <div className="alert alert-danger"><p>{error}</p></div>   
        }
        else if(successMessage != null)
        {
           return <div className="alert alert-success"><p>{successMessage} </p></div>         
        }
        return null;
    }

    render() {
        const { loading } = this.props.paperworkEntryStore;
        const { image } = this.state;
        const { goBack } = this.props.routerStore;
        const { editorState } = this.state;

        if (loading) {
            return <Loader />
        }
        if (image) {
            return (
                <div>
                    <div className="clear">
                        <h3 className="pull type--medium">Edit Image</h3>
                        <button className="push btn btn--med btn--primary" onClick={goBack}>
                            Back
                        </button>
                    </div>
                    <div className="separator--primary spc--bottom--sml spc--top--sml"></div>

                    <div className="row">
                        <div className="col col-sml-12 col-lrg-5 spc--bottom--med">
                            <div className="box box--sml box--white box__shadow--1 ">
                            <h4 className="type--small type--bold type--letterspace--wide type--uppercase spc--bottom--sml">Image</h4>
                                <div className="box__img-holder">
                                    <img src={image.url} alt="Image"/>
                                </div>
                            </div>
                        </div>
                        <div className="col col-sml-12 col-lrg-7">
                            <div className="box box--sml box--white box__shadow--1">
                                <h4 className="type--small type--bold type--letterspace--wide type--uppercase spc--bottom--sml">Data</h4>
                                {
                                <form onSubmit={this.handleSubmit}>
                                {/* TODO: later use FormInput */}
                                    <label className="spc--bottom--sml display--ib"> Name </label>
                                    <input className="input input--text input--med spc--bottom--tiny" type="text" value={image.name} onChange={this.handleChange} />

                                    <label className="spc--bottom--sml display--ib"> Image Text </label>
         
                                    <Editor
                                     editorState={editorState}
                                    toolbarClassName="toolbarClassName"
                                    wrapperClassName="wrapperClassName"
                                    editorClassName="editorClassName"
                                    onEditorStateChange={this.onEditorStateChange}
                                    />
                                    <br/>
                                    {this.renderUpdateResultMessage()}
                                    <input className="btn btn--med btn--primary" type="submit" value="Submit" />
                                </form>
                            }                                            
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        return <Loader />
    }
}
export { PaperworkEntryImageEditPage }


// WEBPACK FOOTER //
// ./src/pages/PaperworkEntryImageEditPage.js